import { InputTag } from 'mixs/base/input_mixin';
// const flatpickr = require('flatpickr/dist/flatpickr').default;
// console.log(flatpickr)
import flatpickr from 'flatpickr';
const Japanese = require("flatpickr/dist/l10n/ja.js").Japanese;

export class InputsDaterange extends InputTag {
  datePicker:      any; // FlatpickrInstance
  init(){
    super.init();
    this.listenMount([this.onMoutInputsDate])
  }
  onMoutInputsDate(){
    this.setDatePicker();
  }
  setDatePicker(){
    let options:Partial<any>          = this.datePickerOptions();
    if(this.opts.value.match(this.formatValue())){
      options['defaultDate'] = this.opts.value.split(',')
    }
    this.datePicker      = flatpickr(this.dateInput(), options);
  }
  onChangeDate(selectedDates, dateStr, instance){
    this.dispatch({date: {value: dateStr}} );
  }
  datePickerOptions(){
    return {
      mode:   "range",
      wrap: false,
      locale: Japanese
    };
  }
  onChange(e){
    let value = e.target.value;
    if(!value.match(this.formatDisplay())){
      this.opts.value = ''
    } else {
      this.opts.value = value.split(' to ').join(',');
    }
    this.update();
  }
  dateInput(): HTMLInputElement {
    return <HTMLInputElement>this.querySelector('input[data-type="date"]');
  }
  formatDisplay(){
    // format: YYYY-MM-DD to YYYY-MM-DD
    return /^\d{4}-\d{2}-\d{2} to \d{4}-\d{2}-\d{2}$/i
  }
  formatValue(){
    // format: YYYY-MM-DD,YYYY-MM-DD
    return /^\d{4}-\d{2}-\d{2},\d{4}-\d{2}-\d{2}$/i
  }
}

riot.mixin("inputs.daterange", InputsDaterange as riot.TagMixin)
